import type { Component } from './Component';

// TODO: add this to Entity2D when children can be added to any entity
export class ActiveComponent implements Component {
  public static readonly NAME = 'active';
  public worldActive!: boolean;
  private _active = true;

  public init(): void {
    this.worldActive = true;
    this._active = true;
  }

  public get active() {
    return this._active;
  }
  public set active(val) {
    this._active = val;
  }
}
